import React, { useState } from 'react';
import './Products.css';
import './ProductsActions.css';
import './MobileResponsive.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const CustomerGroups = ({ isActive, searchTerm, onSearchChange, onShowFilters }) => {
    // Mock data as no API endpoint identified yet
    const [groups, setGroups] = useState([
        { id: 1, name: 'Retail', percentage: '0', selling_price_group: 'Default' },
        { id: 2, name: 'Wholesale', percentage: '10', selling_price_group: 'Wholesale Price' },
    ]);

    // Lifted search state to parent
    // const [searchTerm, setSearchTerm] = useState(''); 
    const [perPage, setPerPage] = useState(25);
    const [openActionId, setOpenActionId] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);

    // Derived state for search
    const filteredGroups = groups.filter(group => 
        group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        group.selling_price_group.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleActionMenu = (id) => {
        setOpenActionId(openActionId === id ? null : id);
    };

    const handleViewGroup = (group) => {
        if (!group) return;
        setSelectedGroup(group);
        setShowViewModal(true);
        setOpenActionId(null);
    };

    const handleCloseModal = () => {
        setShowViewModal(false);
        setSelectedGroup(null);
    };

    const handleExport = (format) => {
        if (!filteredGroups || filteredGroups.length === 0) {
            alert('No data to export');
            return;
        }

        const headers = ['Customer Group Name', 'Calculation Percentage (%)', 'Selling Price Group'];
        const rows = filteredGroups.map(g => [
            g.name || '', g.percentage || '0', g.selling_price_group || 'Default'
        ]);

        const title = 'Customer Groups List';
        const filename = 'customer_groups';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();
    };

    return (
        <>
            {/* Filters Header - Simplified as groups usually have fewer filters */}
            {/* Table Controls */}
            <div className="table-controls">
                <div className="table-controls-left">
                    <div className="entries-dropdown">
                        <span>Show</span>
                        <select value={perPage} onChange={(e) => setPerPage(Number(e.target.value))}>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span>entries</span>
                    </div>
                </div>

                <div className="table-controls-center">
                    <button className="export-btn" onClick={() => handleExport('CSV')}><i className="fa fa-file-csv"></i> Export CSV</button>
                    <button className="export-btn" onClick={() => handleExport('Excel')}><i className="fa fa-file-excel"></i> Export Excel</button>
                    <button className="export-btn" onClick={() => handleExport('Print')}><i className="fa fa-print"></i> Print</button>
                    <button className="export-btn"><i className="fa fa-columns"></i> Column visibility</button>
                    <button className="export-btn" onClick={() => handleExport('PDF')}><i className="fa fa-file-pdf"></i> Export PDF</button>
                </div>

                <div className="table-controls-right">
                    <div className="tabs-search-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <input
                            type="text"
                            placeholder="Search Customer Groups..."
                            value={searchTerm}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="tabs-search-input"
                        />
                        <button
                            className="filter-toggle-btn"
                            onClick={onShowFilters}
                            title="Open Filters"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
                            </svg>
                            Filters
                        </button>
                    </div>
                    <button className="control-btn-primary" onClick={() => console.log('Add Group')}>
                        <span className="plus-icon">+</span> Add
                    </button>
                    <button className="control-btn-primary" style={{ marginLeft: '1rem', backgroundColor: '#3b82f6' }}>
                        <i className="fa fa-download" style={{ marginRight: '0.5rem' }}></i> Download Excel
                    </button>
                </div>
            </div>

            <div className="products-table-container">
                <table className="products-table">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Customer Group Name</th>
                            <th>Calculation Percentage (%)</th>
                            <th>Selling Price Group</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredGroups.map(group => (
                            <tr key={group.id}>
                                <td className="actions-cell">
                                    <div className="action-dropdown-container">
                                        <button className="action-btn-trigger" onClick={() => toggleActionMenu(group.id)}>
                                            Actions <span className="arrow-down">▼</span>
                                        </button>
                                        {openActionId === group.id && (
                                            <div className="action-dropdown-menu">
                                                <button onClick={() => handleViewGroup(group)}>View</button>
                                                <button onClick={() => console.log('Edit', group.id)}>Edit</button>
                                                <button onClick={() => console.log('Delete', group.id)}>Delete</button>
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td>{group.name}</td>
                                <td>{group.percentage}</td>
                                <td>{group.selling_price_group}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', borderTop: '1px solid #e2e8f0' }}>
                <div>Showing {groups.length} entries</div>
            </div>

            {/* View Customer Group Modal */}
            {showViewModal && (
                <div className="modal-overlay">
                    <div className="modal-container" style={{ maxWidth: '520px', width: '95%' }}>
                        <div className="modal-header">
                            <h2>View Customer Group</h2>
                            <button className="modal-close-btn" onClick={handleCloseModal}>✕</button>
                        </div>
                        <div className="modal-content" style={{ padding: '1.5rem' }}>
                            <div className="record-details">
                                <div><strong>Group Name:</strong> {selectedGroup?.name || 'N/A'}</div>
                                <div><strong>Calculation Percentage:</strong> {selectedGroup?.percentage || '0'}%</div>
                                <div><strong>Selling Price Group:</strong> {selectedGroup?.selling_price_group || 'N/A'}</div>
                                <div><strong>Status:</strong> {selectedGroup?.status || 'Active'}</div>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ justifyContent: 'flex-end' }}>
                            <button className="modal-btn close-btn" onClick={handleCloseModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CustomerGroups;
